// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/verifiedIcon.svg';

export default function () {
  return <Icon alt="verified" aria-label="Verified" />;
}
